<template>
  <ContentSection>
    <Container indent="wide" class="">
      <div class="-mx-10 bg-blue-10 p-6 sm:-mx-0 md:p-18">
        <div
          class="mb-6 flex justify-between lg:mb-10 lg:items-center lg:gap-24"
        >
          <div>
            <!-- TITLE -->
            <h2
              v-if="data.heading"
              class="default-component-title pr-6"
              v-html="$replaceHtmlTags(data.heading)"
            />

            <!-- TEXT -->
            <div
              v-if="data.text"
              class="text-link -mr-8 mt-4 max-w-text text-base sm:mt-5 sm:text-md md:mr-0"
              v-html="data.text"
            />
          </div>
          <!-- BUTTON -->
          <button
            class="flex h-fit shrink-0 items-center gap-3 p-3 text-base text-blue-800 sm:gap-4 sm:text-md"
            @click="open = !open"
          >
            <div class="hidden lg:block">
              <Transition name="fade" mode="out-in">
                <span v-if="!open">
                  {{ data.expand_button_text }}
                </span>
                <span v-else>
                  {{ data.collapse_button_text }}
                </span>
              </Transition>
            </div>

            <ArrowSimpleIcon
              class="h-2 shrink-0 grow-0 transition-transform sm:h-2"
              :class="{
                'rotate-180': open,
                'rotate-0': !open,
              }"
            />
          </button>
        </div>
        <AnimatedContainer>
          <TransitionExpand
            class="w-full overflow-hidden transition-all duration-300 ease-in-out"
            :open="open"
          >
            <div class="ul-list-style-dot prose max-w-none sm:prose-big">
              <ul
                class="-mr-2 -translate-x-2 sm:-mr-3 sm:-translate-x-3 lg:columns-2 lg:gap-20"
              >
                <li v-for="(item, index) in data.list" :key="index">
                  {{ item }}
                </li>
              </ul>
            </div>
          </TransitionExpand>
        </AnimatedContainer>
      </div>
    </Container>
  </ContentSection>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, required: true },
})

const open = ref(props.data.initial_expanded || false)
</script>
